export default class form {
	init () {
		this.clearBtn();
	}

	clearBtn(){
		$('.c-form_search_clear').click(function() {
			$(this).prev('input[type="search"]').val('');
		});
	}
}


// WEBPACK FOOTER //
// ./src/assets/js/modules/form.js